<h2 mat-dialog-title>Deportistas en la orden de compra</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.usuario }}
          <br />
          <small>{{ element.documento }}</small>
        </td>
      </ng-container>

            <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container> 

            <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Ingreso hasta (dd-mm-aaaa)</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaNueva | date: 'dd-MM-yyyy' }}</td>
      </ng-container>  

      <ng-container matColumnDef="plan">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let element">{{ element.plan }}</td>
      </ng-container>

      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let element">{{ element.valor | currency:'':'symbol':'1.0-0' }}</td>
      </ng-container>

<!--       <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado registro OC</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.estado == 0">Pendiente</span>
          <span *ngIf="element.estado == 1">Aceptada</span>
          <span *ngIf="element.estado == 2">Cancelada</span>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="estadoUsuario">
        <th mat-header-cell *matHeaderCellDef>Estado usuario</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.estadoUsuario == 0">Registrado</span>
          <span *ngIf="element.estadoUsuario == 1">Activado</span>
          <span *ngIf="element.estadoUsuario == 2">Inactivo</span>
          <span *ngIf="element.estadoUsuario == 3">Bloqueado</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="comentario">
        <th mat-header-cell *matHeaderCellDef>Comentario</th>
        <td mat-cell *matCellDef="let element">{{ element.comentario }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Aceptar</button>
</mat-dialog-actions>
